import React from 'react';
import { Layout } from '../components/common';
import { 
  AboutHeroSection,
  MissionSection,
  ValuesSection
} from '../components/about';

const AboutPage: React.FC = () => {
  return (
    <Layout>
      <AboutHeroSection />
      <MissionSection />
      <ValuesSection />
    </Layout>
  );
};

export default AboutPage;